import * as React from 'react';

import { ISetRedundantSupply, IUpdatePowerSupply, IUpdateProSupport, IUpdateSlotsWithNumber } from '../../../actions';
import { IBudget } from '../../../types/store/budget';
import { ISlotsItems } from '../../../types/store/slotsItems';
import { getEnergySupplyId } from '../../../utils/manageBudgetSlots';
import { needMoreSupply } from '../../../utils/manageRouterSlots';
import { ISlotInfo } from './..';
import ItemForm from './ItemForm';
import RadioForm from './RadioForm';

export interface IOptionsButtonGroup {
  label: string;
  prefix: string;
  onClick: IUpdateProSupport;
  options: {
    value: string;
    label: string;
    isChecked: boolean;
    disabled: boolean;
  }[];
}

interface IFormConfiguratorProps {
  budget: IBudget;
  slotsItems: ISlotsItems;
  slotsInfo: ISlotInfo[];
  updateProSupport: IUpdateProSupport;
  updatePowerSupply: IUpdatePowerSupply;
  setRedundantSupply: ISetRedundantSupply;
  updateSlotsWithNumber: IUpdateSlotsWithNumber;
}

const FormConfigurator: React.SFC<IFormConfiguratorProps> = props => {
  const selectedEnergySupplyId = getEnergySupplyId(props.budget);

  const optionsSupply: IOptionsButtonGroup = {
    label: 'Power Supply',
    prefix: 'powerSupply',
    onClick: props.updatePowerSupply,
    options: [
      {
        value: 'none',
        label: 'No',
        isChecked: selectedEnergySupplyId === '',
        disabled: false
      },
      {
        value: '600W PSU',
        label: '600W',
        isChecked: selectedEnergySupplyId === '600W PSU',
        disabled: needMoreSupply(
          props.budget.slots.front.slotsSpecs,
          [{ name: '', filled: '600W PSU' }],
          props.slotsItems
        )
      },
      {
        value: '1,200W PoE PSU',
        label: '1200W',
        isChecked: selectedEnergySupplyId === '1,200W PoE PSU',
        disabled: false
      }
    ]
  };

  const optionsDobleSupply: IOptionsButtonGroup = {
    label: 'Power Supply redundancy?',
    prefix: 'powerSupplyRedundancy',
    onClick: props.setRedundantSupply,
    options: [
      {
        value: 'false',
        label: 'No',
        isChecked: props.budget.slots.back.slotsSpecs.length === 1,
        disabled: props.budget.slots.back.slotsSpecs.length === 0
      },
      {
        value: 'true',
        label: 'YES',
        isChecked: props.budget.slots.back.slotsSpecs.length === 2,
        disabled: props.budget.slots.back.slotsSpecs.length === 0
      }
    ]
  };

  const optionsProSupport: IOptionsButtonGroup = {
    label: 'Installation Service Contract?',
    prefix: 'proSupport',
    onClick: props.updateProSupport,
    options: [
      {
        value: 'none',
        label: 'No',
        isChecked: !props.budget.proSupport.remoteService && !props.budget.proSupport.onsiteService,
        disabled: false
      },
      {
        value: 'remoteService',
        label: 'Remote',
        isChecked: props.budget.proSupport.remoteService,
        disabled: false
      },
      {
        value: 'onsiteService',
        label: 'Onsite',
        isChecked: props.budget.proSupport.onsiteService,
        disabled: false
      }
    ]
  };

  return (
    <div className="section bigboy-configuration col-md-5 col-xxl-12 hidePDF">
      <form id="bigboy-form" className="row-xl">
        {props.slotsInfo.map(slotInfo => (
          <ItemForm key={slotInfo.id} {...slotInfo} onClick={props.updateSlotsWithNumber} />
        ))}

        <div className="form-group col-xxl-4 power-supply">
          <label>{optionsSupply.label}</label>
          <RadioForm {...optionsSupply} />
        </div>

        <div className="form-group col-xxl-4 power-redundancy">
          <label>{optionsDobleSupply.label}</label>
          <RadioForm {...optionsDobleSupply} />
        </div>

        <div className="form-group col-xxl-4 installation-service">
          <label>{optionsProSupport.label}</label>
          <RadioForm {...optionsProSupport} />
        </div>
      </form>
    </div>
  );
};

export default FormConfigurator;



// WEBPACK FOOTER //
// ./src/components/Configurator/FormConfigurator/index.tsx